import { render } from "./property-list-single.vue?vue&type=template&id=8995473c&scoped=true"
import script from "./property-list-single.vue?vue&type=script&lang=js"
export * from "./property-list-single.vue?vue&type=script&lang=js"

import "./property-list-single.vue?vue&type=style&index=0&id=8995473c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8995473c"]])

export default __exports__